/*
 * @Author: Zhouqi
 * @Date: 2025-11-26 18:23:35
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-03-12 11:02:26
 */
// 官网
export const IndexURL = '/';
// 产品首页
export const homeURL = '/home';
// 爆款模板
export const viralTemplateURL = '/ai-viral-template';
// 视频生成
export const videoGenerateURL = '/ai-video-generator';
// 图片生成
export const imageGenerateURL = '/ai-image-generator';
// 视频翻译
export const videoTranslateURL = '/video-translator';
// 数字人视频2.0
export const avatarVideoProURL = '/ai-avatar-generator';
// 产品数字人
export const productAvatarURL = '/ai-product-avatar';
// 视频换脸
export const faceSwapperURL = '/face-swap';
// 声音克隆
export const voiceCloneURL = '/ai-voice-cloning';

// 素材库
export const libraryURL = '/library';

// 价格页
export const pricingURL = '/pricing';

export const notFoundURL = '/404';

export const PolicyURL = '/privacy';

export const TermsURL = '/terms';

export const MemberURL = '/member';

// 图片高清
export const imageEnhanceURL = '/ai-image-enhancer';

// 图片翻译
export const imageTranslationURL = '/ai-image-translator';

// 智能擦除
export const aiRemovalURL = '/video-subtitle-remover';

// 视频编辑
export const aiVideoEditURL = '/ai-video-editor';

// AI TikTok 视频生成
export const aiTiktokVideoURL = '/features/ai-tiktok-video-generator';

// AI UGC 视频生成
export const aiUgcVideoURL = '/ai-ugc-video-generator';

// 爆款复刻
export const viralRemakeURL = '/ai-viral-remake';
// 商品链接分析
export const productAnalyzerURL = '/tools/product-analyzer';
// AI Twin Generator
export const aiTwinGeneratorURL = '/ai-twin-generator';

// Sora 2 Pro 模型落地页
export const sora2ProURL = '/models/sora-2-pro';

// Seedance 2.0 模型落地页
export const seedance20URL = '/models/seedance-2-0';

// Facebook Video Ad Creator
export const facebookVideoAdURL = '/facebook-video-ad-creator';

// Dropshipping Video Ads Maker
export const dropshippingVideoAdsURL = '/dropshipping-video-ads-maker';

// AI Reel Generator
export const aiReelGeneratorURL = '/ai-reel-generator';
